import { ReactNode } from 'react';

export enum ErrorMessageType {
  /** Error caused something to be stopped. */
  error = 'error',
  /** Warn the user that something bad happened, but their action continued. */
  warning = 'warning'
}

export type ErrorMessage = {
  /** Message to display for the error. */
  message?: ReactNode;
  /** Called when the user closes the error message. */
  onClose?: () => void;
  /** Title of the error. */
  title?: ReactNode;
  /** Type of error that happened @default @see ErrorMessageType.error. */
  type?: ErrorMessageType;
};
